import React, { useEffect, useMemo, useState } from 'react';
import LeaderboardTestItem from './LeaderboardTestItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import useStageResults from '../../../../useStageResults';
import { buildTestLeaderboardRows } from '../../utils/testResults';

const guestTextColors = [
  '#63AA57', '#6EB9E3', '#758AF8', '#8DEACE',
  '#B6F875', '#A2DDEA', '#9988FF', '#BECEF6', '#BCEAA0',
  '#ECA3A3', '#F5FF88', '#F875D3', '#FFBEA2', '#FFE5A2'
];

const createColorMapping = (data) => {
  const colorMapping = {};
  let colorIndex = 0;
  data.forEach((item) => {
    const inGroup = (item.inGroup || '').trim();
    if (!inGroup || colorMapping[inGroup]) return;
    colorMapping[inGroup] = guestTextColors[colorIndex % guestTextColors.length];
    colorIndex++;
  });
  return colorMapping;
};


const TestLeaderboard = ({
  selectedEventID,
  selectedCompetitionID,
  selectedStageID,
  selectedClassificationID,
  selectedGroupID,
  stageStatus,
  stageStatusDesc,
}) => {
  const [showScrollButton, setShowScrollButton] = useState(false);
  const { stageResults, loading, error } = useStageResults(
    selectedEventID,
    selectedCompetitionID,
    selectedStageID,
    selectedClassificationID,
    selectedGroupID
  );

  useEffect(() => {
    const toggleScrollButton = () => {
      if (window.pageYOffset > 300) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener('scroll', toggleScrollButton);

    return () => window.removeEventListener('scroll', toggleScrollButton);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const leaderboardData = useMemo(
    () => buildTestLeaderboardRows(stageResults),
    [stageResults]
  );

  const colorMapping = useMemo(
    () => createColorMapping(stageResults),
    [stageResults]
  );

  const hasResults = leaderboardData.length > 0;

  if (loading) {
    return <div className="loading-spinner"></div>;
  }

  if (error) {
    return (
      <div className="notification has-text-centered mt-1">
        <strong>{error}</strong>
      </div>
    );
  }

  return (
    <div>
    {stageStatus ? (
        <div className="section">
            <div className="notification has-text-centered mt-1">
                <p>Odcinek odwołany {stageStatusDesc}</p>
            </div>
        </div>
    ) : (
      <div className="section columns">
        {hasResults ? (
          <div className="columns result-table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
            <div style={{ backgroundColor: 'white' }}>
              {leaderboardData.map((data, index) => (
                <LeaderboardTestItem
                  key={`${data.positionNumber ?? data.PositionNumber ?? ''}-${index}`}
                  data={data}
                  colorMapping={colorMapping}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className="notification has-text-centered mt-1">
            <strong>Brak danych</strong>
          </div>
        )}
        {showScrollButton && (
          <button onClick={scrollToTop} className="scroll-to-top-btn">
            <FontAwesomeIcon icon={faArrowUp} size="2x" />
          </button>
        )}
      </div>
    )}
    </div>
  );
};

export default TestLeaderboard;
